import { BarChart3, Download, Link2, MousePointerClick } from 'lucide-react'
import { useSearchParams } from 'react-router-dom'
import OpenClawLandingPage from '../components/openclaw/OpenClawLandingPage'
import Ad360DisplayDownloadButtons from '../components/openclaw/Ad360DisplayDownloadButtons'

function OpenClawAd360Display() {
  const [searchParams] = useSearchParams()
  const qhclick = String(searchParams.get('qhclick') || searchParams.get('qhclickid') || '').trim()
  const sourceId = String(searchParams.get('sourceid') || '').trim()
  const trackingInfo = qhclick
    ? { channelType: 'search', paramName: 'qhclick', clickId: qhclick }
    : sourceId
      ? { channelType: 'display', paramName: 'sourceid', clickId: sourceId }
      : null

  return (
    <OpenClawLandingPage
      theme="rose"
      productName="OpenClaw"
      showFriendLinks={false}
      seo={{
        title: 'OpenClaw 下载',
        description: 'OpenClaw 下载页，提供适用于不同系统版本的安装包下载入口。',
        keywords: 'OpenClaw下载, OpenClaw安装包, 官方下载'
      }}
      hero={{
        eyebrow: 'OpenClaw 下载',
        title: 'OpenClaw 下载',
        subtitle: '下载并开始使用 OpenClaw',
        description:
          '本页面提供 OpenClaw 不同系统版本的安装包下载入口，帮助你快速选择适合当前设备的版本。\n下载安装完成后，即可按客户端正常流程启动并登录使用。',
        tags: ['官方下载', '安装包下载', '多系统版本', '登录使用'],
        guideTitle: '下载、安装、登录即可开始使用',
        guideDescription: '按页面步骤选择系统版本下载安装包，完成安装后使用客户端正常登录即可。',
        guideBullets: [
          '根据你的设备系统选择对应版本下载安装包。',
          '安装完成后打开客户端并完成登录。',
          '如遇重复下载或重新安装，不影响正常使用。'
        ]
      }}
      screenshotCaption="该页面以官方下载安装体验为主，同时兼顾后续安装与登录流程。"
      highlights={[
        {
          icon: MousePointerClick,
          title: '官方入口清晰',
          description: '页面提供直接、清晰的下载入口，帮助用户快速找到适合自己系统的版本。'
        },
        {
          icon: Download,
          title: '多系统版本下载',
          description: '支持 Windows、Mac Intel 和 Mac Apple 版本下载，降低用户选错安装包的概率。'
        },
        {
          icon: BarChart3,
          title: '安装后即可使用',
          description: '下载安装完成后，用户可以直接进入客户端并按正常流程登录使用。'
        }
      ]}
      steps={[
        {
          title: '进入官方下载页',
          description: '用户通过链接进入本页面后，可直接查看适合自己设备的安装包版本。'
        },
        {
          title: '用户点击下载',
          description: '选择对应系统版本后即可开始下载，流程与普通官方下载体验保持一致。'
        },
        {
          title: '按步骤完成安装',
          description: '下载完成后按系统提示安装客户端，首次打开后即可进入登录流程。'
        },
        {
          title: '登录后开始使用',
          description: '登录成功后即可开始使用 OpenClaw，不需要额外操作。'
        }
      ]}
      sections={[
        {
          title: '下载安装流程简单直接',
          description:
            '本页面按照常见官方下载页的方式组织内容，用户只需要选择正确系统版本下载安装，再完成登录即可正常使用。'
          ,
          items: [
            'Windows、Mac Intel、Mac Apple 版本入口清晰。',
            '下载、安装、登录三个步骤衔接顺畅。',
            '重复下载或重新安装不会影响正常使用。',
            '页面信息简洁，便于快速完成版本选择。'
          ]
        },
        {
          title: '下载信息清晰易懂',
          description: '页面只保留用户下载、安装和登录所需的信息，阅读路径更直接，使用起来更顺手。',
          items: [
            '页面风格统一，下载安装入口更直观。',
            '不同系统版本的下载按钮一目了然。',
            '安装完成后可直接进入客户端登录。',
            '适合首次下载和重复下载安装使用。'
          ]
        }
      ]}
      closing={{
        title: '选择系统版本并开始下载',
        description: '请直接选择你的系统版本下载 OpenClaw 安装包，完成安装后即可登录并开始使用。',
        footerTitle: '下载、安装、登录一步完成',
        footerDescription: '选择适合你的系统版本下载安装包，完成安装后即可启动客户端并正常登录使用。',
        footerTags: ['OpenClaw下载', '多系统版本', '安装体验', '客户端下载']
      }}
      downloadContent={<Ad360DisplayDownloadButtons theme="rose" trackingInfo={trackingInfo} />}
    />
  )
}

export default OpenClawAd360Display
